// src/App.jsx
import React from "react";
import karanvir from "../Assets/Karanvirsaini.jpg"
import praveer from "../Assets/Sihota-Praveer-_20240724-01-1-2-1024x1021.jpg"
import remnaresh from "../Assets/ram_naresh.jpeg"
import abhimanyu from "../Assets/Abhimanyu-Kiran.jpg"
import piyush from "../Assets/piyush_lakhani.jpeg"
import abhishek from "../Assets/abhisheck.jpeg"
import manoj from "../Assets/Manoj-Dounkal.jpg"
import piyush_uneyal from "../Assets/piyush_uniyal.jpeg"
import krashan from "../Assets/krashn.jpeg"
import akash from "../Assets/Aakash-Soni-3.jpg"
import anshul from "../Assets/anshul.jpeg"
import raja from "../Assets/raja_dew.jpg"
import sourav from "../Assets/souravkumar.jpg"
import waqar from "../Assets/waqar.jpg"
import jaganath from "../Assets/jaganath.jpeg"
import arghyadipta from "../Assets/arghyadipta.jpg"
import kalyan from "../Assets/kalyan.jpeg"

import amit from "../Assets/Capture.jpg"
import deonath from "../Assets/deonath.jpg"
import manjit from "../Assets/Manjit-maam-250x300.jpg"

import amitjha from "../Assets/amit_jha.jpg"
import amitsarna from "../Assets/amit_sarna.jpeg"
import jitender from "../Assets/jitender.jpeg"
import jonny from "../Assets/jony.jpg"
import satyapal from "../Assets/satyapalsingh.jpg"
import sanjay from "../Assets/Sanjay-Soni.jpg"
import chenjerai from "../Assets/Capture1-edited.jpg"

import saroj from "../Assets/saroj.jpeg"
import mayank from "../Assets/Mayank.jpeg"
import dummy from "../Assets/dummy.jpg"

function PhdStudents() {

    const peopleData = [
        {
          name: "Dr. Karanvir Saini",
          position: "Postdoctoral Fellow",
          affiliation: "University of Pennsylvania",
          country: "USA",
          category: "Postdoc",
          image:karanvir,
          description: "Currently, I am a postdoctoral researcher at the University of Pennsylvania (UPenn). I am an engineer with a broader interest in understanding the role of physical forces in structure-function relationships during the physiology and pathology of tissues. Presently, I am studying the influence of mechanical load on tissue collagen turnover and its underpinning molecular mechanisms."
          
        },
        {
          name: "Dr. Praveer Sihota",
          position: "Postdoctoral Fellow",
          affiliation: "University Medical Center Hamburg-Eppendorf",
          country: "Germany",
          category: "Postdoc",
          image:praveer,
          description: "My research focuses on the multiscale characterization of bone, with a special interest in the effects of prolonged hyperglycemia on bone mineralization, collagen quality, and skeletal fragility. I am particularly interested in exploring non-invasive diagnostic techniques to assess bone quality. Through multiscale bone quality assessments, I explore the underlying mechanisms of pathological changes in bone, aiming to understand how these factors contribute to increased fracture risk. These findings are crucial for developing new clinically relevant information to improve the diagnosis and treatment of fragility fractures."
        },
        {
          name: "Dr. Ram Naresh Yadav",
          position: "Postdoctoral Fellow",
          affiliation: "Henry Ford Health",
          country: "USA",
          category: "Postdoc",
          image:remnaresh,
          description: "My research interests are in bone mechanics and changes in bone properties caused by various pathological conditions. My PhD research focused on the impact of type 2 diabetes and osteoporosis on bone quality. In my PhD research, I developed a finite element model to predict changes in bone strength caused by various pathological conditions. My current research is centered on the development of a tool for in-vivo measurement of bone structure and mechanical properties using an experimental, imaging, and finite element approach. The goal of this study is to create a clinical tool for assessing bone quality that can identify those at risk and monitor the effectiveness of therapy."
        },
        {
          name: "Dr. Abhimanyu Kiran",
          position: "Postdoctoral Fellow",
          affiliation: "University of Glasgow",
          country: "UK",
          category: "Postdoc",
          image:abhimanyu,
          description: "We have explored the plausible leader- follower mechanism that could be responsible for collective cell migration of the epithelial cell monolayer. Our experimental finding suggests that mechanical interaction among the follower cells causes the formation of leader cells. We have successfully demonstrated that distinct modes of collective cell migration are governed by the initial boundary condition used for the formation of the monolayer. We observed rapid & highly aligned collective cell migration in the monolayer formed using fixed boundary conditions and slow & less aligned collective cell migration in the monolayer formed using free boundary conditions. We have also shown the effect of the serum starvation on the mechanical properties of the epithelial cell monolayer. The cells of the monolayer subjected to the serum starvation was unable to recover to their original condition after the removal of the load and exhibited permanent deformation."
        },
        {
          name: "Dr. Piyush Lakhani",
          position: "Senior Research Engineer",
          affiliation: "Spirax Sarco",
          country: "UK",
          category: "Postdoc",
          image:piyush,
          description: "His area of interest is to develop a non-invasive device for measuring in vivo mechanical properties of planar tissues. Using these devices, He measured the anisotropic, viscoelastic properties of the skin, Also, He established a relation among the direction of Krassel’s line, the orientation of collagen fibre and the young modulus of the skin. He also proposed a modulus based method to measure the In-Plane dispersion of collagen fibres, inventively. He also used constitutive modelling to capture the mechanical response of skin using inverse finite element analysis."
        },
        {
          name: "Dr. Abhishek Tiwari",
          position: "Assistant Professor",
          affiliation: "MNNIT Allahabad (Prayagraj)",
          country: "India",
          category: "Postdoc",
          image:abhishek,
          description: "I am interested in exploring the role of mechanobiological environment involved in skeletal remodeling and adaptation. Currently, I am trying to develop biomechanical therapeutics which can be beneficial in mitigation of osteoporosis. In addition, I am also working in the area of bone fracture healing assessment and progression, and implant design."
        },
        {
          name: "Dr. Manoj Kumar Dounkal",
          position: "Scientist",
          affiliation: "DRDO",
          country: "India",
          category: "Postdoc",
          image:manoj,
          description: ""
        },
        {
          name: "Dr. Piyush Uniyal",
          position: "Postdoctoral Fellow",
          affiliation: "KU Leuven",
          country: "Belgium",
          category: "Postdoc",
          image:piyush_uneyal,
          description: "My research area is structural and mechanical characterization of bone under dynamic loading conditions. I am investigating factors influencing the deformation behaviour of cortical bone at high strain rates. I am using experimental as well as finite element analysis techniques to understand the fracture behaviour of bone. I am also investigating various bone quality parameters such as cortical porosity, organic matrix and microcracks for better assessment of bone fracture risk prediction."
        },
        {
          name: "Dr. Krashn Kumar Dwivedi",
          position: "Postdoctoral Fellow",
          affiliation: "Washington University in Saint Louis",
          country: "USA",
          category: "Postdoc",
          image:krashan,
          description: "His area of interest is to understand the biomechanics of healthy and diabetic skin tissue using an experimental and modeling approach. As the skin is the prime barrier against external aggression and protects the underlying tissue from mechanical stresses. In his research work, he performed ex vivo and in vivo studies where he investigated the effect of different loading conditions and diabetes on the different hierarchy of skin tissue. He measured the non-linear elastic, anisotropic, poroelastic and viscoelastic properties of the skin. During his research work, he used different experimental techniques such as uniaxial, biaxial, bulge, nanoindentation, AFM and FTIR-ATR techniques and also he developed the constitutive model and implemented it in Abaqus through User define subroutine. His research work is helpful during plastic surgery, skin graft etc."
        },
        {
          name: "Dr. Aakash Soni",
          position: "Postdoctoral Fellow",
          affiliation: "University of Bristol",
          country: "UK",
          category: "Postdoc",
          image:akash,
          description: "He is working on a femoral head fracture. His research interest is to predict bone fracture using computational modeling techniques , bone mechanics, XIGA composites, and fracture mechanics."
        },
        {
          name: "Dr. Anshul Sharma",
          position: "Postdoctoral Fellow",
          affiliation: "IIT Delhi",
          country: "India",
          category: "Postdoc",
          image:anshul,
          description: "He is working on Noninvasive/ Non-Destructive Testing & Evaluation, Theoretical Modeling/Green’s Function Modeling, Finite Element Modeling and Simulation/ Numerical Modeling, Infrared/Thermal wave Imaging, Industrial and Biomedical Imaging, Signal and Image Processing, Structural Health Monitoring and Diagnosis."
        },
      
        // Current PhD Students
        {
          name: "Saroj Kumar",
          position: "PhD Scholar",
          affiliation: "IIT Ropar",
          country: "India",
          category: "PhD",
          image:saroj,
          description: "He began his Ph.D. in July 2019 and is currently researching BONE Quality deterioration caused by chronic kidney disease-mineral bone disorder (CKD-MBD) and other pathological conditions (T2DM, OI, FIO, Charcot, Osteoprotic, AVN, etc..). Most of his work is experimental, with some involving finite element (FE) analysis using Abaqus to study bone at nano, micro, and macro scales. He uses various techniques to assess bone quality, including (a) For structural analysis: Micro-CT (µ-CT), Simpleware ScanIP-3D Image Segmentation Software (b) Whole bone mechanical analysis: Compression test, Tensile tests, DMA, creep and stress relaxation behavior, DIC, and 3- & 4-point bending tests. (c) Material properties using:FTIR-ATR mode, TGA, XRD. (d) Spectroscopy-based analysis: FE-SEM, SEM, Raman Spectroscopy, XPS, LSCM, Fluorescence microscopy, AFM, Bone Histomorphometry, Bio-Quants Software Analysis, and Solid-State NMR. (e) Nano- & Micro level analysis: Nanoindentation test, cRPI, Bio-Dent, hardener tests (like Vickers, Brinell, and Rockwell). (f) Histology-based analysis: like H & E stain etc.."
        },
        {
          name: "Raja Dewangan",
          position: "PhD Scholar",
          affiliation: "IIT Ropar",
          country: "India",
          category: "PhD",
          image:raja,
          description: "His research focuses on understanding sound wave propagation through various media and developing advanced noise control solutions using sonic crystals. He explores the intricate behavior of sound waves and how they interact with different environments, both indoor and outdoor. By leveraging the unique properties of sonic crystals, his work aims to create innovative methods for reducing noise pollution. This research has significant applications in improving acoustic environments in diverse settings, from industrial spaces to public areas, enhancing overall sound quality and contributing to quieter, more peaceful surroundings. He is also working on the DRDO-TBRL project entitled “High Speed Impact Dynamic and Deformation Analysis of Target- Projectile System using 3D-DIC Technique.”"
        },
        {
          name: "Sourav Kumar",
          position: "PhD Scholar",
          affiliation: "IIT Ropar",
          country: "India",
          category: "PhD",
          image:sourav,
          description: "I received my B.Tech degree in Mechanical Engineering from Guru Nanak Dev University Amritsar, Punjab, India, in July 2020. I joined Ph.D. in the Department of Mechanical Engineering, Indian Institute of Technology, Ropar in December 2020 and my research interest is in biomechanics of soft tissues."
        },
        {
          name: "Mohd. Waqar Khan",
          position: "PhD Scholar",
          affiliation: "IIT Ropar",
          country: "India",
          category: "PhD",
          image:waqar,
          description: "Mohd Waqar Khan is a PhD student at IIT Ropar, specializing in biomechanics with a focus on bone mechanics. Holding an MTech in Machine Design from Aligarh Muslim University, he integrates engineering principles into biomedical research. His work aims to innovate orthopedic devices and improve bone health treatments. Waqar is dedicated to interdisciplinary collaboration and advancing the field through pioneering research."
        },
        {
          name: "Mayank",
          position: "PhD Scholar",
          affiliation: "IIT Ropar",
          country: "India",
          category: "PhD",
          image:mayank,
          description: "His research experience spans various domains, including knee osteoarthritis, rheumatoid arthritis, pancreatic cancer, and chronic pancreatitis. His main skills include primary culture from pancreatic adenocarcinoma tissue, preparation of cell blocks from monolayer cultures and their immunofluorescence, scanning electron microscopy, and immunohistochemistry and immunofluorescence of cartilage tissues, pancreatic tissue, keloid tissue, and submucosal glands. He is proficient in histological techniques, ranging from the procurement of human and animal tissues to processing for paraffin embedding, microtomy, and staining (Hematoxylin & Eosin, Safranin O, and Toluidine blue staining). He also has experience in cell culture monolayer staining methods, including crystal violet,senescence-associated beta-galactosidase, Alcian blue, Alizarin Red S, and Oil Red O. His skill set includes DNA isolation, gene expression analysis, ELISA, spectrophotometry, immunoblotting, whole transcriptome sequencing, LC-MS, cell-based molecular assays, and drug cytotoxicity assays (MTT, SOD assay, apoptosis, ROS, and mitochondrial staining with MitoSOX, JC-1, and MitoTracker). Additionally, he is experienced in confocal microscopy, animal experiments, drug testing, and using scientific software such as BD FACSDiva. His expertise in flow cytometry techniques encompasses operating FACS DIVA software, compensation, expression of CD markers in primary cultures, Annexin V-PI assays, cell cycle analysis, and evaluation of intracellular ROSactivity using DCFDA in primary cultured cells. He is also skilled in conventional and real-time PCR (Roche LC-96 and ABI) and preparation of protein samples for LC-MS. Furthermore, he has extended his research interests to include 3D bioprinting, scaffold design, and biomechanics of cartilage tissue."
        },
        {
          name: "Jaganath Anand Gaonkar",
          position: "PhD Scholar",
          affiliation: "IIT Ropar",
          country: "India",
          category: "PhD",
          image:jaganath,
          description: "Jaganath Anand Gaonkar is a PhD student at IIT Ropar, specializing in biomechanics."
        },     {
          name: "Arghyadipta Shit",
          position: "2024BMZ0012",
          affiliation: "DBT JRF",
          country: "",
          category: "PhD",
          image:arghyadipta,
          description: "Jaganath Anand Gaonkar is a PhD student at IIT Ropar, specializing in biomechanics."
        },     {
          name: "Kalyan Dandapat",
          position: "2024BMZ0008",
          affiliation: "UGC-JRF",
          country: "",
          category: "PhD",
          image:jaganath,
          description: "Jaganath Anand Gaonkar is a PhD student at IIT Ropar, specializing in biomechanics."
        },
      
        // Part-Time / ERP
        {
          name: "Amit Kumar",
          position: "Part-Time Scholar",
          affiliation: "",
          country: "India",
          category: "Part-time",
          image:amit,
          description: ""
        },
        {
          name: "Deonath Kumar",
          position: "Assistant Professor",
          affiliation: "Bihar Engineering College",
          country: "India",
          category: "Part-time",
          image:deonath,
          description: ""
        },
        {
          name: "Manjit Sandhu",
          position: "Assistant Professor",
          affiliation: "Guru Nanak Dev University",
          country: "India",
          category: "Part-time",
          image:manjit,
          description: ""
        },
        {
          name: "Amit Jha",
          position: "Senior Manager",
          affiliation: "Hindustan Aeronautics Limited",
          country: "India",
          category: "Part-time",
          image:amitjha,
          description: ""
        },
        {
          name: "Amit Sarna",
          position: "Chief Manager, Engine R&D",
          affiliation: "SML ISUZU Ltd.",
          country: "India",
          category: "Part-time",
          image:amitsarna,
          description: ""
        },
        {
          name: "Jitender Singh",
          position: "Manager, Engine R&D",
          affiliation: "SML ISUZU Ltd.",
          country: "India",
          category: "Part-time",
          image:jitender,
          description: ""
        },
        {
          name: "Jonny Singla",
          position: "Assistant Professor",
          affiliation: "SLIET Longowal, Sangrur",
          country: "India",
          category: "Part-time",
          image:jonny,
          description: ""
        },
        {
          name: "Satyapal Singh",
          position: "Researcher",
          affiliation: "Semi-Conductor Laboratory (SCL)-ISRO, Mohali",
          country: "India",
          category: "Part-time",
          image:satyapal,
          description: ""
        },
        {
          name: "Sanjay Kumar Soni",
          position: "Scientist",
          affiliation: "DRDO, Chandigarh",
          country: "India",
          category: "Part-time",
          image:sanjay,
          description: "His research focuses on characterizing material behavior under dynamic loading conditions. With advancements in finite element analysis (FEA) software, it is now possible to predict the dynamic response of materials through numerical simulations. The primary objective of his research is to determine the Johnson-Cook strength and damage parameters, which will be validated through high-velocity impact experiments. Additionally, a morphology study will be conducted to examine the effects of high strain rates and temperature on plastic deformation and failure mechanisms."
        },
      
        // International
        {
          name: "Chenjerai Zizhou",
          position: "PhD Scholar",
          affiliation: "IIT Ropar",
          country: "Zimbabwe",
          category: "International",
          image:chenjerai,
          description: "Chenjerai Zizhou is a Ph.D. research scholar at the Indian Institute of Technology Ropar. He is a registered member of the Zimbabwe Institute of Engineers (ZIE) and the Engineering Council of Zimbabwe (ECZ). Engineer C. Zizhou obtained his Bachelor of Technologyhonours degree in Electronic Engineering at Harare Institute of Technology. He received his master’s of Technology in Biomedical Engineering at SRM Institute of Science and Technology. Engineer C. Zizhou was a lecturer and later a chairperson of the Biomedical Engineering Department at the Harare Institute of Technology. His research areas are biomechanics, biomaterials, and medical devices."
        }
      ];
      
      const groupedByCategory = peopleData.reduce((acc, person) => {
        if (!acc[person.category]) {
          acc[person.category] = [];
        }
        acc[person.category].push(person);
        return acc;
      }, {});
      

    return (
        <div className="min-h-screen bg-white">

<div className="min-h-screen bg-white p-4 font-serif">
      {Object.entries(groupedByCategory).map(([category, people]) => (
        <div key={category} className="mb-12">
          {/* ✅ Category Heading */}
          <h2 className="text-2xl font-bold text-cyan-800 uppercase mb-6 text-center border-b pb-2">
            {category} Students
          </h2>

          {/* ✅ People under this category */}
          {people.map((person, index) => (
            <div key={index} className="mb-8">
              {/* Divider */}
              <div className="w-full h-1 bg-cyan-500 m-4"></div>

              {/* Image */}
              <img
                src={person.image || dummy} // fallback image
                alt={person.name}
                className="w-48 h-48 rounded shadow mb-4 mt-4 mx-auto"
              />

              {/* Name, Position, Affiliation */}
              <p className="font-semibold text-sm mb-2 text-center">
                {person.name}<br />
                {person.position}{person.affiliation && `, ${person.affiliation}`}<br />
                {person.country}
              </p>

              {/* Description */}
              <em className="font-semibold mb-4 text-black text-justify block">
                {person.description}
              </em>

              {/* Bottom Divider */}
              <div className="w-full h-1 bg-cyan-500"></div>
            </div>
          ))}
        </div>
      ))}
    </div>
        </div>
    );
}

export default PhdStudents;
